import { Component, DestroyRef, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AccessOptions } from '@shared/models/accessOptions.model';
import { FormationsGroups } from '@shared/models/formationsGroups.model';
import { HospitalNames } from '@shared/models/hospitalTypes.model';
import { InstanceIdService } from '@shared/services/instance-id.service';
import { SubscriptionManager } from '@shared/services/subscription-manager.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { CalendarService } from 'src/app/shared/services/calendar.service';
import { UserService } from 'src/app/shared/services/user.service';
import { UtilisService } from 'src/app/shared/services/utilis.service';
import { Profile } from '../../models/profile.model';
import { Specialty } from '../../models/specialty.model';
import { ErrorService } from '../../services/error.service';
import { ProfileService } from '../../services/profile.service';
import { SpecialtyService } from '../../services/specialty.service';
import { ToastService } from '../../services/toast.service';
import { WishesService } from '../../services/wishes.service';
import { toPascalCase } from '../../utils/cross-functions';
import { CustomDateAdapterForDay } from '../../utils/custom-date-adapter';
import posthog from 'posthog-js';

@Component({
  selector: 'app-relaunch-availability',
  templateUrl: './relaunch-availability.component.html',
  styleUrls: ['./relaunch-availability.component.scss'],
  providers: [{ provide: DateAdapter, useClass: CustomDateAdapterForDay }],
  standalone: false,
})
export class RelaunchAvailabilityComponent implements OnInit {
  private instanceId: string;

  public toPascalCase = toPascalCase;

  public formGroup: any;

  public isSending: boolean = false;

  public message: string = '';

  // IBODE et IDE -> IBODE/IDE : one checkbox
  // AS -> AS : one checkbox
  // IBODE et IDE et AS -> Infirmiere : two checkbox
  // Anesthésistes -> Anesthésiste : one checkbox
  // Iade -> Iade : one checkbox
  // Anesthésistes et Iade -> ANESTHESIST_IADE : two checkbox
  public specialties: Specialty[] | any[] | undefined;

  public profilesPositions: { label: string; value: string }[] = [];

  public profiles: any[] | undefined;

  public ratedProfiles: any[] | undefined;

  public filteredProfiles: any[] = [];

  public selectedProfiles: any[] = [];

  public chosenPosition: any = [];

  public chosenResidencies: any = [];

  public chosenSeniorities: string[] = [];

  public chosenSpecialty: any;

  public loadingProfiles: boolean = false;

  public targeted: boolean = false;

  public competenceFilter: boolean = false;

  public showRole: boolean = true;

  public popupLoading: boolean = true;

  public profileType: string = '';

  public type: string = '';

  private principalHospitalId: string | undefined;

  public residencies: { label: string; value: string; isChecked: boolean; isDisabled: boolean }[] = [];

  public seniorities: { label: string; value: string; isChecked: boolean; isDisabled: boolean }[] = [];

  public typeInfOptions = [
    {
      label: 'Aide Opératoire',
      value: 'Aide Opératoire',
    },
    {
      label: 'Circulante',
      value: 'Circulante',
    },
  ];

  public typeAnesthOptions = [
    {
      label: '',
      value: 'Bloc',
    },
    {
      label: '',
      value: 'Consultation',
    },
  ];

  public currentUser: any;

  public isDateValid: boolean = false;

  public disabled: boolean = false;

  public isSpinning: boolean = false;

  public showSeniority: boolean = false;

  public formationsGroupOfPosition: FormationsGroups | undefined;

  public seniorityValid: boolean = false;

  public isNurse: boolean = false;

  public saveButtonTooltip: string = 'Les dates ne sont pas valides';

  public isMultiHospitals: boolean = false;

  public hospitals: any[] = [];

  public selectedHospitalsId: any;

  private accessOptions: AccessOptions | undefined;

  public hospitalNames: HospitalNames;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogRef: MatDialogRef<RelaunchAvailabilityComponent>,
    private readonly formBuilder: FormBuilder,
    private readonly calendarService: CalendarService,
    private readonly utilisService: UtilisService,
    private readonly userService: UserService,
    private readonly router: Router,
    private readonly storageService: StorageService,
    private readonly toastService: ToastService,
    private readonly specialtyService: SpecialtyService,
    private readonly errorService: ErrorService,
    private readonly wishesService: WishesService,
    private readonly profileService: ProfileService,
    private destroyRef: DestroyRef,
    private subscriptionManager: SubscriptionManager,
    private instanceIdService: InstanceIdService
  ) {
    this.instanceId = this.instanceIdService.generateId();
    this.subscriptionManager.registerComponent(this.instanceId, this.destroyRef);
    this.hospitalNames = this.userService.getHospitalNames();
    this.typeAnesthOptions[0].label = this.hospitalNames.blocName;
    this.typeAnesthOptions[1].label = this.hospitalNames.consultationName;
  }

  async ngOnInit() {
    if (!this.data.topAccessOptions) {
      this.accessOptions = this.userService.getAccessOptionsOfPage(this.router.url);
    } else {
      this.accessOptions = this.data.topAccessOptions;
    }

    if (this.accessOptions?.seniority) {
      this.seniorities = [];
      this.accessOptions.seniority.forEach((seniority: string) => {
        this.seniorities.push({
          label: seniority,
          value: seniority,
          isChecked: false,
          isDisabled: false,
        });
      });
    }

    if (this.accessOptions?.residencyInPopUp) {
      this.residencies = [];
      this.accessOptions.residencyInPopUp.forEach((residency: string) => {
        this.residencies.push({
          label: residency,
          value: residency,
          isChecked: false,
          isDisabled: false,
        });
      });
    }

    this.getProfileType();
    this.getCurrentUser();
    this.isMultiHospitals = this.userService.isCurrentUserHasMultipleHospitalsSelected();
    this.currentUser = this.storageService.getUser();
    this.principalHospitalId = this.storageService.getData('principalHospitalId');
    this.selectedHospitalsId = this.userService.getSelectedHospitals();
    this.selectedHospitalsId.forEach((hospitalId: any) => {
      const hospital = this.currentUser.profile.hospitals.find(
        (hospital: any) => String(hospital._id) == String(hospitalId)
      );
      if (hospitalId === this.principalHospitalId) {
        this.hospitals.unshift({
          name: hospital.name,
          _id: hospital._id,
          displayName: this.userService.resolveHospitalName(hospital._id),
        });
      } else {
        this.hospitals.push({
          displayName: this.userService.resolveHospitalName(hospital._id),
          name: hospital.name,
          _id: hospital._id,
        });
      }
    });
    this.setPositions();
    this.specialties = await this.fetchSpecialties();
    if (this.isNurse) {
      this.isNursesNeeded(this.chosenSpecialty);
    } else {
      this.isAnesthNeeded(this.chosenSpecialty);
    }
    await this.makeForm();
    this.initListeners();

    await this.actualiseValid(null, null);
    if (this.data.specialty && this.data.role) {
      const specialtyFound = this.specialties.find(
        (specialty: any) => String(specialty._id) === String(this.data.specialty._id)
      );
      this.formGroup.get('specialty').setValue(specialtyFound ? specialtyFound._id : this.specialties[0]._id);
    } else {
      this.formGroup.get('specialty').setValue(this.specialties[0]._id);
    }
    this.popupLoading = false;
    if (this.competenceFilter) {
      this.getProfilesBySpecialty(this.profileType).then((res: any) => {
        this.ratedProfiles = res;
        this.loadingProfiles = false;
      });
    } else {
      const hospitalId = this.isMultiHospitals ? this.hospitals[0]._id : this.selectedHospitalsId[0];
      this.getProfiles(hospitalId).then((res: any) => {
        this.profiles = res;
        this.loadingProfiles = false;
        this.filterProfiles();
      });
    }
  }

  async actualiseValid(position: any, seniority: any) {
    if (!position) {
      position = this.formGroup.value.position;
    }
    if (!seniority) {
      seniority = this.formGroup.value.seniority;
    }
    if (!position || position.length === 0) {
      this.seniorityValid = false;
      return;
    }

    this.formationsGroupOfPosition = await this.userService.getFormationsGroupOfProfile({
      position: Array.isArray(position) ? position[0] : position,
    });
    this.showSeniority = this.formationsGroupOfPosition?.isUsingSeniorities ?? false;

    if (!this.showSeniority) {
      this.seniorityValid = true;
    } else if (this.showSeniority) {
      this.seniorityValid = seniority.length >= 1;
    }
  }

  initListeners(): void {
    this.subscriptionManager
      .createRequest(this.formGroup.controls['startDate'].valueChanges, 'startDateForm', this.instanceId)
      .subscribe({
        next: () => {
          this.updateIsDateValid();
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });

    this.subscriptionManager
      .createRequest(this.formGroup.controls['endDate'].valueChanges, 'endDateForm', this.instanceId)
      .subscribe({
        next: () => {
          this.updateIsDateValid();
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });

    this.subscriptionManager
      .createRequest(this.formGroup.get('specialty').valueChanges, 'specialtyForm', this.instanceId)
      .subscribe({
        next: (val: any) => {
          this.chosenSpecialty = val;
          if (this.isNurse) {
            this.isNursesNeeded(val);
          } else {
            this.isAnesthNeeded(val);
          }
          this.filterProfiles();
          this.formGroup.controls['selectAllProfiles'].setValue(false);
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });

    this.subscriptionManager
      .createRequest(this.formGroup.get('position').valueChanges, 'positionForm', this.instanceId)
      .subscribe({
        next: async (val: any) => {
          this.formationsGroupOfPosition = await this.userService.getFormationsGroupOfProfile({
            position: val,
          });
          this.showSeniority = this.formationsGroupOfPosition?.isUsingSeniorities ?? false;
          await this.actualiseValid(val, null);
          this.formGroup.controls['selectAllProfiles'].setValue(false);
          this.chosenPosition = val;

          this.filterProfiles();
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });

    this.subscriptionManager
      .createRequest(this.formGroup.get('seniority').valueChanges, 'seniorityForm', this.instanceId)
      .subscribe({
        next: async (val: any) => {
          await this.actualiseValid(null, val);
          this.chosenSeniorities = val;
          if (this.competenceFilter) {
            this.filterProfiles();
          } else {
            this.filterProfiles();
          }
          this.formGroup.controls['selectAllProfiles'].setValue(false);
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });

    this.subscriptionManager
      .createRequest(this.formGroup.get('targeted').valueChanges, 'targetedForm', this.instanceId)
      .subscribe({
        next: (val: any) => {
          this.targeted = val;
          if (val) {
            this.filterProfiles();
          }
          this.formGroup.controls['selectAllProfiles'].setValue(false);
          this.formGroup.controls['competenceFilter'].setValue(false);
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });

    this.subscriptionManager
      .createRequest(this.formGroup.get('competenceFilter').valueChanges, 'competenceFilterForm', this.instanceId)
      .subscribe({
        next: (val: any) => {
          this.competenceFilter = val;
          if (val) {
            this.getProfilesBySpecialty(this.profileType).then((res: any) => {
              this.ratedProfiles = res;
              this.loadingProfiles = false;
              this.filterProfiles();
              this.formGroup.controls['selectAllProfiles'].setValue(false);
            });
          } else {
            this.filterProfiles();
          }
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });

    if (this.isNurse) {
      this.subscriptionManager
        .createRequest(this.formGroup.get('typeInf').valueChanges, 'typeInfForm', this.instanceId)
        .subscribe({
          next: (val: any) => {
            this.typeInfOptions.forEach((role: any) => {
              if (val === role.value) {
                this.type = role.value;
              }
            });

            this.filterProfiles();
            this.formGroup.controls['selectAllProfiles'].setValue(false);
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    } else {
      this.subscriptionManager
        .createRequest(this.formGroup.get('typeAnesth').valueChanges, 'typeAnesthForm', this.instanceId)
        .subscribe({
          next: (val: any) => {
            if (val == this.typeAnesthOptions[0].value) {
              this.type = 'bloc';
            }
            if (val == this.typeAnesthOptions[1].value) {
              this.type = 'consultation';
            }
            this.formGroup.controls['selectAllProfiles'].setValue(false);
            this.filterProfiles();
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    }

    this.subscriptionManager
      .createRequest(this.formGroup.controls['residency'].valueChanges, 'residencyForm', this.instanceId)
      .subscribe({
        next: (val: any) => {
          this.chosenResidencies = val;
          this.filterProfiles();
          this.formGroup.controls['selectAllProfiles'].setValue(false);
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });

    this.subscriptionManager
      .createRequest(
        this.formGroup.controls['selectAllProfiles'].valueChanges,
        'selectAllProfilesForm',
        this.instanceId
      )
      .subscribe({
        next: (val: any) => {
          this.selectAll(this.filteredProfiles, val);
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  async onChangeService() {
    this.loadingProfiles = true;
    this.profiles = [];
    this.ratedProfiles = [];
    this.filteredProfiles = [];

    this.setPositions();
    this.formGroup.get('position').setValue(this.profilesPositions[0].value);
    this.formationsGroupOfPosition = await this.userService.getFormationsGroupOfProfile({
      position: Array.isArray(this.formGroup?.get('position')?.value)
        ? this.formGroup?.get('position')?.value[0]
        : this.formGroup?.get('position')?.value,
    });
    this.showSeniority = this.formationsGroupOfPosition?.isUsingSeniorities ?? false;

    if (this.accessOptions?.isAnesthMode) {
      this.getAnesthSpecialties();
      this.getProfilesBySpecialty(this.formGroup.value.position).then((res: any) => {
        this.ratedProfiles = res;
        this.filterProfiles();
      });
    } else {
      this.fetchSpecialties().then(async (specialties: any) => {
        this.specialties = specialties;
        this.showSeniority = this.formationsGroupOfPosition?.isUsingSeniorities ?? false;
        await this.actualiseValid(null, null);
        this.formGroup.get('specialty').setValue(this.specialties?.[0]._id);
      });
      this.getProfilesBySpecialty(this.formGroup.value.position).then((res: any) => {
        this.ratedProfiles = res;
        this.filterProfiles();
      });
    }
    this.filterProfiles();
  }

  updateIsDateValid(): void {
    this.isDateValid = this.getStartDate <= this.getEndDate;
  }

  setPositions() {
    const selectedHospitalId = this.formGroup?.get('hospitals')?.value?._id ?? this.hospitals?.[0]?._id;
    this.chosenPosition = [this.data.position[0].name];

    this.profilesPositions = this.data.position
      .filter((pos: any) => String(pos.hospital) === String(selectedHospitalId))
      .map((position: any, index: any) => {
        return {
          label: position.name,
          value: position.name,
          isChecked: index === 0,
        };
      });
  }

  getCurrentUser(): void {
    this.currentUser = this.userService.getCurrentUser();
  }

  async makeForm() {
    const foundSpecialty = this.data.specialty
      ? this.specialties?.find((specialty: any) => String(specialty._id) === String(this.data.specialty._id))
      : undefined;
    const foundRole = this.data.role
      ? this.typeInfOptions.find((role: any) => String(role.value) === String(this.data.role.name))
      : undefined;
    if (!this.isMultiHospitals) {
      if (this.isNurse) {
        this.formGroup = this.formBuilder.group({
          startDate: [this.data.date ? this.data.date : '', [Validators.required]],
          endDate: [this.data.date ? this.data.date : '', [Validators.required]],
          position: [[this.profilesPositions[0].value], [Validators.required]],
          residency: [this.residencies[0].value, [Validators.required]],
          seniority: [[]],
          specialty: [
            this.data.specialty && this.data.role && foundSpecialty ? foundSpecialty : this.specialties?.[0],
            [Validators.required],
          ],
          targeted: [this.data.specialty && this.data.role ? true : false, [Validators.required]],
          competenceFilter: [this.data.specialty && this.data.role ? true : false, [Validators.required]],
          selectAllProfiles: [false],
          typeInf: [foundRole ? foundRole.value : 'Aide Opératoire', [Validators.required]],
        });
      } else {
        this.formGroup = this.formBuilder.group({
          startDate: [this.data.date ? this.data.date : '', [Validators.required]],
          endDate: [this.data.date ? this.data.date : '', [Validators.required]],
          position: [this.profilesPositions[0].value, [Validators.required]],
          residency: [this.residencies[0].value, [Validators.required]],
          seniority: [[]],
          specialty: [
            this.data.specialty && this.data.role && foundSpecialty ? foundSpecialty : this.specialties?.[0],
            [Validators.required],
          ],
          targeted: [this.data.specialty && this.data.role ? true : false, [Validators.required]],
          competenceFilter: [this.data.specialty && this.data.role ? true : false, [Validators.required]],
          selectAllProfiles: [false],
          typeAnesth: ['Bloc', [Validators.required]],
        });
      }
    } else {
      if (this.isNurse) {
        this.formGroup = this.formBuilder.group({
          startDate: [this.data.date ? this.data.date : '', [Validators.required]],
          endDate: [this.data.date ? this.data.date : '', [Validators.required]],
          position: [[this.profilesPositions[0].value], [Validators.required]],
          residency: [this.residencies[0].value, [Validators.required]],
          seniority: [[]],
          specialty: [
            this.data.specialty && this.data.role && foundSpecialty ? foundSpecialty : this.specialties?.[0],
            [Validators.required],
          ],
          targeted: [this.data.specialty && this.data.role ? true : false, [Validators.required]],
          competenceFilter: [this.data.specialty && this.data.role ? true : false, [Validators.required]],
          selectAllProfiles: [false],
          typeInf: [foundRole ? foundRole.value : 'Aide Opératoire', [Validators.required]],
          hospitals: [this.hospitals[0], [Validators.required]],
        });
      } else {
        this.formGroup = this.formBuilder.group({
          startDate: [this.data.date ? this.data.date : '', [Validators.required]],
          endDate: [this.data.date ? this.data.date : '', [Validators.required]],
          position: [this.profilesPositions[0].value, [Validators.required]],
          residency: [this.residencies[0].value, [Validators.required]],
          seniority: [[]],
          specialty: [
            this.data.specialty && this.data.role && foundSpecialty ? foundSpecialty : this.specialties?.[0],
            [Validators.required],
          ],
          targeted: [this.data.specialty && this.data.role ? true : false, [Validators.required]],
          competenceFilter: [this.data.specialty && this.data.role ? true : false, [Validators.required]],
          selectAllProfiles: [false],
          typeAnesth: ['Bloc', [Validators.required]],
          hospitals: [this.hospitals[0], [Validators.required]],
        });
      }
    }

    this.targeted = this.data.specialty && this.data.role ? true : false;
    this.competenceFilter = this.data.specialty && this.data.role ? true : false;
    if (this.competenceFilter) {
      this.getProfilesBySpecialty(this.profileType).then((res: any) => {
        this.ratedProfiles = res;
        this.loadingProfiles = false;
        this.filterProfiles();
        this.formGroup.controls['selectAllProfiles'].setValue(false);
      });
    } else {
      this.filterProfiles();
    }

    this.formationsGroupOfPosition = await this.userService.getFormationsGroupOfProfile({
      position: this.formGroup?.get('position')?.value[0],
    });
    this.showSeniority = this.formationsGroupOfPosition?.isUsingSeniorities ?? false;
  }

  close(): void {
    this.dialogRef.close();
  }

  public get getStartDate() {
    return this.formGroup.controls['startDate'].value;
  }

  public get getEndDate() {
    return this.formGroup.controls['endDate'].value;
  }

  changedEditor(event: any) {
    this.message = event['editor']['root']['innerHTML'];
  }

  changeSelectAllState() {
    const allChecked = this.filteredProfiles.every((profile: any) => profile.checked || !profile.haveUser);
    this.formGroup.get('selectAllProfiles').setValue(allChecked, { emitEvent: false });
  }

  fetchSpecialties(): Promise<Specialty[]> {
    if (this.isNurse) {
      return this.getNurseSpecialties();
    } else {
      return this.getAnesthSpecialties();
    }
  }

  getAnesthSpecialties() {
    return new Promise<Specialty[]>((resolve: any) => {
      let blocSpecialties: any[] = [];
      let consultationSpecialties: any[] = [];
      this.subscriptionManager
        .createRequest(
          this.wishesService.getWishesByProfileAndType(this.currentUser.profile._id, 'bloc'),
          'getWishesByProfileAndTypeBloc',
          this.instanceId
        )
        .subscribe({
          next: (result: any) => {
            result = result.filter(
              (s: any) =>
                s.specialty.name !== 'DEFAULT_' &&
                s.specialty.name !== 'Bariatrique' &&
                !s.specialty.isEmergency &&
                s.specialty.name !== 'Anesthésie-réanimation' &&
                !s.specialty.name.match(/extra/i)
            );

            blocSpecialties = result.map((obj: any) => obj.specialty);

            this.subscriptionManager
              .createRequest(
                this.wishesService.getWishesByProfileAndType(this.currentUser.profile._id, 'consultation'),
                'getWishesByProfileAndTypeConsult',
                this.instanceId
              )
              .subscribe({
                next: (result: any) => {
                  result = result.filter(
                    (s: any) =>
                      s.specialty.name !== 'DEFAULT_' &&
                      s.specialty.name !== 'Bariatrique' &&
                      !s.specialty.isEmergency &&
                      s.specialty.name !== 'Anesthésie-réanimation' &&
                      !s.specialty.name.match(/extra/i)
                  );

                  consultationSpecialties = result.map((obj: any) => obj.specialty);

                  const specialties = [...(blocSpecialties || []), ...(consultationSpecialties || [])].reduce(
                    (acc: any[], curr: any) => {
                      if (!acc.some((item: any) => item._id === curr._id)) {
                        acc.push(curr);
                      }
                      return acc;
                    },
                    []
                  );
                  resolve(specialties);
                },

                error: (error: any) => {
                  this.errorService.handleError(error);
                },
              });
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    });
  }

  getNurseSpecialties() {
    return new Promise<Specialty[]>((resolve: any, reject: any) => {
      this.subscriptionManager
        .createRequest(this.specialtyService.getAllSpecialties(), 'getAllSpecialties', this.instanceId)
        .subscribe({
          next: (specialties: Specialty[]) => {
            if (specialties && specialties.length > 0) {
              specialties = specialties.filter((s: any) => s.name !== 'DEFAULT_');
              resolve(specialties);
            }
          },
          error: (error: any) => {
            this.errorService.handleError(error);
            reject(error);
          },
        });
    });
  }

  getProfileType() {
    this.chosenResidencies.push(this.residencies[0].value);
    if (!this.accessOptions?.isAnesthMode || (window.location.href.endsWith('campaigns') && this.data.isNurse)) {
      this.isNurse = true;
      this.profileType = 'nurse';
      this.type = 'ratedAideOp';
      this.data.position = this.data.position.filter((pos: any) => pos.name != 'IADE' && pos.name != 'Iade');
    } else {
      this.isNurse = false;
      this.profileType = 'anesth';
      this.type = 'bloc';
    }
  }

  getProfilesBySpecialty(position: string) {
    this.loadingProfiles = true;

    return new Promise<any[]>((resolve: any) => {
      this.subscriptionManager
        .createRequest(this.profileService.getProfilesBySpecialty(position), 'getProfilesBySpecialty', this.instanceId)
        .subscribe({
          next: (res: any) => {
            resolve(res);
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    });
  }

  filterProfiles() {
    const profiles =
      this.competenceFilter && !this.chosenPosition.includes('Iade') ? this.ratedProfiles : this.profiles;
    this.filteredProfiles = [];
    if (!profiles || !this.chosenPosition.length || !this.chosenResidencies.length) {
      return;
    }

    if (!this.competenceFilter) {
      this.filteredProfiles = profiles.filter((profile: any) => {
        return (
          this.chosenResidencies.includes(profile.residency) &&
          (!this.isNurse && this.showSeniority ? this.chosenSeniorities.includes(profile.seniority) : true) &&
          this.chosenPosition.includes(profile.position)
        );
      });
      const uniqueIds: any = {};
      const uniqueObjects: any[] = [];

      for (const obj of this.filteredProfiles) {
        const fieldValue = obj['_id'];

        if (!uniqueIds[fieldValue]) {
          uniqueIds[fieldValue] = true;
          uniqueObjects.push(obj);
        }
      }
      this.filteredProfiles = uniqueObjects;
      this.sortProfiles(this.filteredProfiles);

      return;
    } else {
      if (this.chosenPosition.includes('Iade')) {
        this.filteredProfiles =
          this.profiles?.filter((profile: any) => {
            return (
              profile.specialties &&
              profile.specialties.find((specialty: any) => String(specialty) === this.chosenSpecialty)
            );
          }) ?? [];
        return;
      }
      const specialty = this.specialties?.find((obj: any) => obj._id == this.chosenSpecialty);

      specialty.needs.forEach((role: any) => {
        if (role.role.name === this.type) {
          this.type = role.role._id;
        }
      });
      this.filteredProfiles = profiles
        .map((profilesBySpecialty: any) => {
          if (
            profilesBySpecialty &&
            profilesBySpecialty.specialty &&
            profilesBySpecialty.specialty._id == this.chosenSpecialty &&
            profilesBySpecialty[this.type] &&
            profilesBySpecialty[this.type].length
          ) {
            return { ...profilesBySpecialty[this.type] };
          }

          return undefined;
        })
        .filter((profile: any) => {
          return profile != undefined;
        });
      if (!this.filteredProfiles || !this.filteredProfiles[0]) {
        return;
      }
      this.filteredProfiles = Object.keys(this.filteredProfiles[0]).map((key: any) => this.filteredProfiles[0][key]);

      this.filteredProfiles = this.filteredProfiles.filter((profile: any) => {
        return (
          profile &&
          this.chosenResidencies.includes(profile.residency) &&
          (!this.isNurse && this.showSeniority && !this.chosenPosition.includes('Iade')
            ? this.chosenSeniorities.includes(profile.seniority)
            : true) &&
          this.chosenPosition.includes(profile.position)
        );
      });
    }
  }

  sortProfiles(profiles: Profile[]) {
    if (!profiles) {
      return;
    }
    profiles = profiles.sort((a: any, b: any) => {
      if (a.firstName?.localeCompare(b.firstName ?? '') !== 0) {
        //if 2 firstNames don't have the same sort
        return a.firstName?.toLowerCase().localeCompare(b.firstName?.toLowerCase() ?? '');
      } else {
        // else compare by lastname
        return a.lastName?.toLowerCase().localeCompare(b.lastName?.toLowerCase() ?? '');
      }
    });
  }

  filterNurses(profiles: any[]) {
    const selectedFormations = this.formGroup.value.position;
    profiles = profiles.filter((profile: any) => {
      return selectedFormations.includes(profile.position);
    });
    return profiles;
  }

  getProfiles(hospitalId: any) {
    this.loadingProfiles = true;
    let position = this.isNurse ? 'Infirmiere' : this.chosenPosition;
    if (position == 'Anesthésiste') {
      position = 'anesth';
    }
    return new Promise<any[]>((resolve: any) => {
      this.subscriptionManager
        .createRequest(
          this.profileService.getProfilesWithUserByPositionResidencyFromHospital(
            hospitalId,
            position,
            null,
            null,
            '',
            this.accessOptions?.seniority?.length ? this.accessOptions?.seniority?.join(', ') : undefined,
            true,
            false
          ),
          'getProfiles',
          this.instanceId
        )
        .subscribe({
          next: (res: any) => {
            if (this.isNurse) {
              this.filterNurses(res.docs);
            }
            this.loadingProfiles = false;
            resolve(res.docs);
          },
          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    });
  }

  getSelectedProfiles() {
    return this.filteredProfiles.filter((profile: any) => profile.checked).map((elet: any) => elet._id);
  }

  selectAll(profiles: any[], check: boolean) {
    profiles.forEach((el: any) => {
      if (!el.haveUser) {
        el.checked = false;
      } else {
        el.checked = check;
      }
    });
  }

  isNursesNeeded(spec: any) {
    const specialty = this.specialties?.find((obj: any) => obj._id == spec);
    if (specialty) {
      this.typeInfOptions = [];

      specialty.needs.forEach((role: any) => {
        this.typeInfOptions.push({
          label: role.role.name,
          value: role.role.name,
        });
      });

      //Evite que le role selectionné soit basé sur la précédente spécialité.
      if (this.data.role) {
        const foundRole = this.typeInfOptions.find((role: any) => String(role.value) === String(this.data.role.name));
        this.formGroup.get('typeInf').setValue(foundRole ? foundRole.value : this.typeInfOptions[0].value);
      } else {
        this.formGroup.get('typeInf').setValue(this.typeInfOptions[0].value);
      }
    }
  }

  isAnesthNeeded(spec: any) {
    if (this.specialties) {
      const specialty = this.specialties.find((obj: any) => obj._id == spec);
      if (specialty) {
        if (specialty.type.length <= 0) {
          this.showRole = false;
          this.typeInfOptions = [];
          return;
        }
        if (specialty.type.length >= 2) {
          this.showRole = true;
          this.typeAnesthOptions = [
            {
              label: this.hospitalNames.blocName,
              value: 'Bloc',
            },
            {
              label: this.hospitalNames.consultationName,
              value: 'Consultation',
            },
          ];
          return;
        }
        if (specialty.type.includes('bloc')) {
          this.showRole = true;
          this.formGroup.get('typeAnesth').setValue('Bloc');

          this.typeAnesthOptions = [
            {
              label: this.hospitalNames.blocName,
              value: 'Bloc',
            },
          ];
          return;
        }
        if (specialty.type.includes('consultation')) {
          this.showRole = true;
          this.formGroup.get('typeAnesth').setValue('Consultation');
          this.typeAnesthOptions = [
            {
              label: this.hospitalNames.consultationName,
              value: 'Consultation',
            },
          ];
          return;
        }
      }
    }
  }

  save() {
    posthog.capture('Complete_Relaunch_Availability');
    this.isSpinning = true;
    this.disabled = true;
    this.selectedProfiles = this.getSelectedProfiles();
    const body = {
      startDate: this.utilisService.formatDate2(this.getStartDate, true),
      endDate: this.utilisService.formatDate2(this.formGroup.controls['endDate'].value, true),
      position: this.formGroup.controls['position'].value,
      residency: this.formGroup.controls['residency'].value,
      seniority: this.showSeniority ? this.formGroup.value.seniority : [],
      targeted: this.formGroup.value.targeted,
      hospital: '',
      profiles: this.selectedProfiles,
      message: this.message,
      individuals: this.selectedProfiles,
    };

    if (this.isMultiHospitals) {
      body.hospital = this.formGroup.value.hospitals._id;
    } else {
      body.hospital = this.currentUser.profile.principalHospitalId;
    }

    if (this.getStartDate.getTime() <= this.formGroup.controls['endDate'].value.getTime()) {
      this.subscriptionManager
        .createRequest(this.calendarService.relaunchAvailability(body), 'relaunchAvailability', this.instanceId)
        .subscribe({
          next: () => {
            this.disabled = false;
            this.isSpinning = false;
            this.close();
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    } else {
      this.toastService.errorToast('La date de début que vous avez sélectionné est plus grande que la date de fin');
    }
  }

  dateChange(event: { startDate: Date; endDate: Date }) {
    this.formGroup.get('startDate').setValue(event.startDate);
    this.formGroup.get('endDate').setValue(event.endDate);
  }
}
